import { ROUTES } from '@/constants/routes';
import { BusinessDetails } from '@/types/businesses';
import { Card, Stack, Typography } from '@mui/material';
import { SVLink } from '../core';
import { useState } from 'react';
import { Status } from '@/types/common';
import BusinessDeactivateModal from './BusinessDeactivateModal';

type BusinessDetailsActionsProps = {
  businessDetails: BusinessDetails;
};

export default function BusinessDetailsActions({
  businessDetails,
}: BusinessDetailsActionsProps) {
  const { uuid, status, company, advisors } = businessDetails;
  const [openDeactivate, setOpenDeactivate] = useState(false);
  const isActive = status === Status.ACTIVE;

  if (!isActive) {
    return null;
  }

  return (
    <>
      <Card variant="fullHeight">
        <Typography variant="h5" mb={2}>
          Actions
        </Typography>
        <Stack spacing={2}>
          <SVLink
            to={`${ROUTES.BANK_ACCOUNT_APPLICATIONS}?businessId=${uuid}&companyId=${company?.uuid}&advisorId=${advisors ? advisors[0].uuid : ''}`}>
            Start Bank Account Application
          </SVLink>
          <SVLink isWarningLink to="" onClick={() => setOpenDeactivate(true)}>
            Deactivate
          </SVLink>
        </Stack>
      </Card>
      <BusinessDeactivateModal
        id={uuid}
        open={openDeactivate}
        setOpen={setOpenDeactivate}
      />
    </>
  );
}
